import React from 'react';
// nodejs library that concatenates classes
import classNames from 'classnames';
// nodejs library to set properties for components
import PropTypes from 'prop-types';
import SwipeableViews from 'react-swipeable-views';

// material-ui components
import { makeStyles } from '@material-ui/core/styles';
import Tab from '@material-ui/core/Tab';
import Tabs from '@material-ui/core/Tabs';

// core components
import GridContainer from 'components/Grid/GridContainer';
import GridItem from 'components/Grid/GridItem';

import styles from 'assets/jss/material-dashboard-pro-react/components/navPillsStyle';

const useStyles = makeStyles(styles);

export default function NavPills(props) {
	const {
		customClasses,
		tabs,
		// eslint-disable-next-line no-unused-vars
		direction,
		color,
		horizontal,
		alignCenter,
		onNavPillsChange,
		onBeforeNavPillsChange,
	} = props;

	const [active, setActive] = React.useState(props.active);
	const handleChange = (event, active) => {
		if (onBeforeNavPillsChange) {
			onBeforeNavPillsChange(() => navTabChange(active));
		} else {
			navTabChange(active);
		}
	};

	const navTabChange = (active) => {
		setActive(active);
		onNavPillsChange &&
			onNavPillsChange({
				activeTabIndex: active,
			});
	};

	const handleChangeIndex = (index) => {
		setActive(index);
		onNavPillsChange &&
			onNavPillsChange({
				activeTabIndex: active,
			});
	};
	const classes = useStyles();

	const previewPillsHeaderClasses = customClasses?.previewPillsHeader ? customClasses.previewPillsHeader : '';
	const flexContainerClasses = classNames({
		[classes.flexContainer]: true,
		[classes.horizontalDisplay]: horizontal !== undefined,
	});
	const tabButtons = (
		<Tabs
			classes={{
				root: `${classes.root} ${previewPillsHeaderClasses}`,
				fixed: classes.fixed,
				flexContainer: flexContainerClasses,
				indicator: classes.displayNone,
			}}
			value={active}
			onChange={handleChange}
			centered={alignCenter}
		>
			{tabs.map((prop, key) => {
				var icon = {};
				if (prop.tabIcon !== undefined) {
					icon['icon'] = <prop.tabIcon className={classes.tabIcon} />;
				}
				const customPillsButtonClass = prop.classes?.previewPillsButtons ? prop.classes.previewPillsButtons : '';
				const pillsClasses = classNames({
					[classes.pills]: true,
					[classes.horizontalPills]: horizontal !== undefined,
					[classes.pillsWithIcons]: prop.tabIcon !== undefined,
					[classes.inactive]: prop.tabIcon !== undefined,
					[customPillsButtonClass]: true,
				});
				return (
					<Tab
						label={prop.tabButton}
						key={key}
						{...icon}
						classes={{
							root: pillsClasses,
							selected: classes[color],
						}}
					/>
				);
			})}
		</Tabs>
	);
	const previewPillsContentClasses = customClasses?.previewPillsContent ? customClasses.previewPillsContent : '';
	const tabContent = (
		<div className={`${classes.contentWrapper} ${previewPillsContentClasses}`}>
			<SwipeableViews
				axis={'x'}
				index={active}
				onChangeIndex={handleChangeIndex}
				style={{ overflowY: 'hidden' }}
			>
				{tabs.map((prop, key) => {
					return (
						<div
							className={`${classes.tabContent} ${active === key ? '' : classes.inactiveTab
								}`}
							key={key}
						>
							{prop.tabContent}
						</div>
					);
				})}
			</SwipeableViews>
		</div>
	);
	return horizontal !== undefined ? (
		<GridContainer>
			<GridItem {...horizontal.tabsGrid}>{tabButtons}</GridItem>
			<GridItem {...horizontal.contentGrid}>{tabContent}</GridItem>
		</GridContainer>
	) : (
			<div>
				{tabButtons}
				{tabContent}
			</div>
		);
}

NavPills.defaultProps = {
	active: 0,
	color: 'primary',
};

NavPills.propTypes = {
	// index of the default active pill
	active: PropTypes.number,
	tabs: PropTypes.arrayOf(
		PropTypes.shape({
			tabButton: PropTypes.string,
			tabIcon: PropTypes.object,
			tabContent: PropTypes.node,
		})
	).isRequired,
	color: PropTypes.oneOf([
		'primary',
		'warning',
		'danger',
		'success',
		'info',
		'rose',
	]),
	direction: PropTypes.string,
	horizontal: PropTypes.shape({
		tabsGrid: PropTypes.object,
		contentGrid: PropTypes.object,
	}),
	alignCenter: PropTypes.bool,
	onNavPillsChange: PropTypes.func,
};
